import log from "bpmn-js-token-simulation/lib/features/log"
import Log from "bpmn-js-token-simulation/lib/features/log/Log"

function getContainer (html) {
  // 清除打印，具体方法往下拉
  cleanPrint()
  const container = document.createElement('div')
  container.setAttribute('id', 'print')
  container.innerHTML = html
  return container
}
// 设置打印样式
function getStyle (myHeight) {
  // 新建的dom不需要在页面展示
  const styleContent = `
    @media print {
      body > :not(.print) {
       display: none;
       -webkit-print-color-adjust:exact;
       -moz-print-color-adjust:exact;
       -ms-print-color-adjust:exact;
       print-color-adjust:exact;
      }
      html,
      body {
        display: block !important;
        background-color: #fff;
      }
      img {
          visibility: hidden;
      }
      #print {
         display: block;
         // 这个地方传入咱们自己需要打印内容设置的高度，就可以打印对应的张数
         height: ${myHeight} !important;
         overflow:hidden
      }
      .el-table__body-wrappe{
        overflow-x: visible !important;
      }
      .el-col-6{
        width:50%  !important;
      }
      .el-col-18{
        width:100%  !important;
      }
      .el-col-24{
        width:100%  !important;
      }
      .el-input.is-disabled .el-input__inner{
        background-color: #ffffff;
        color: #000;
      }
      .print{
        padding:20px 0;
        font-size: 17px;
      }
      .el-table__header-wrapper{
        width:100% !important;
        overflow-x: visible !important;
      }
      .is-scrolling-none{
        overflow-x: visible !important;
      }
      .el-table__body{
        width:100% !important;
      }
      table{
        width:100% !important;
        overflow: hidden !important;
      }
      .el-scrollbar__bar{
        display:none;
      }
      .el-table th.is-leaf, .el-table td{
        width:100%
      }
      .el-table__body-wrapper::-webkit-scrollbar{
        width: 0px !important;
        height:0px !important;
      }
      ::-webkit-scrollbar {
        width: 7px;
        height: 7px;
        background: none;
      }
      th{
        width:100%  !important;
      }
      .print td{
        padding: 15px 10px;
      }
      .base-card-header{
        font-size:16px !important;
      }
      .cell.el-tooltip {
        white-space: wrap !important;
        overflow: visible;
      }
      .cell {
        overflow: visible;
        white-space:wrap;
      }
    }`
  const style = document.createElement('style')
  style.innerHTML = styleContent
  return style
}

// 清空打印内容及DOM
function cleanPrint () {
  const div = document.getElementById('print-container')
  if (div) {
    document.querySelector('body').removeChild(div)
  }
}
export function printHtml (html, myHeight) {
  const style = getStyle(myHeight)
  const print = html
  const container = getContainer(print)
  document.body.appendChild(style)
  document.body.appendChild(container)
  const el = document.querySelectorAll('#print colgroup')
  Array.from(el).forEach(element => {
    [...element.getElementsByTagName('col')].forEach(el => {
      if (el.width.indexOf('%') == -1) {
        const w = +el.width
        el.width = w / 1560 * 100 + '%'
      }
    })
  });
  const td = document.querySelectorAll('#print td')
  Array.from(td).forEach(element => {
    const el = element.querySelectorAll('.cell')[0]
    if (el.style.width) {
      const w = parseInt(el.style.width)
      el.style.width = w / 1560 * 600 + 'px'
    }
  });
  window.print()
  document.body.removeChild(style)
  document.body.removeChild(container)
  const number = document.querySelectorAll('.number')
  if (number) {
    [...number].forEach(item => {
      item.style = 'display:block'
    })
  }
}
